"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: issuing/dispute-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fissuing%2Fdispute-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisputeServiceClient = exports.RetractDisputeResponse = exports.RetractDisputeRequest = exports.OpenDisputeResponse = exports.OpenDisputeRequestUserEvidence = exports.OpenDisputeRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const dispute_reason_1 = require("../common/dispute-reason");
const question_1 = require("./question");
const protobufPackage = 'com.step.issuing.proto';
function createBaseOpenDisputeRequest() {
    return { transactionId: '', reason: dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON, evidence: undefined };
}
exports.OpenDisputeRequest = {
    fromJSON(object) {
        const message = {
            transactionId: isSet(object.transactionId) ? globalThis.String(object.transactionId) : '',
            reason: isSet(object.reason)
                ? (0, dispute_reason_1.disputeReasonFromJSON)(object.reason)
                : dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON,
        };
        if (isSet(object.evidence)) {
            message.evidence = exports.OpenDisputeRequestUserEvidence.fromJSON(object.evidence);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transactionId !== '') {
            obj.transactionId = message.transactionId;
        }
        if (message.reason !== dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON) {
            obj.reason = (0, dispute_reason_1.disputeReasonToJSON)(message.reason);
        }
        if (message.evidence !== undefined) {
            obj.evidence = exports.OpenDisputeRequestUserEvidence.toJSON(message.evidence);
        }
        return obj;
    },
    create(base) {
        return exports.OpenDisputeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOpenDisputeRequest();
        message.transactionId = object.transactionId ?? '';
        message.reason = object.reason ?? dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON;
        message.evidence = (object.evidence !== undefined && object.evidence !== null)
            ? exports.OpenDisputeRequestUserEvidence.fromPartial(object.evidence)
            : undefined;
        return message;
    },
};
function createBaseOpenDisputeRequestUserEvidence() {
    return { description: [], blobIds: [] };
}
exports.OpenDisputeRequestUserEvidence = {
    fromJSON(object) {
        const message = {
            description: globalThis.Array.isArray(object?.description)
                ? object.description.map((e) => question_1.Question.fromJSON(e))
                : [],
        };
        if (globalThis.Array.isArray(object?.blobIds)) {
            message.blobIds = object.blobIds.map((e) => globalThis.String(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.description?.length) {
            obj.description = message.description.map((e) => question_1.Question.toJSON(e));
        }
        if (message.blobIds?.length) {
            obj.blobIds = message.blobIds;
        }
        return obj;
    },
    create(base) {
        return exports.OpenDisputeRequestUserEvidence.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOpenDisputeRequestUserEvidence();
        message.description = object.description?.map((e) => question_1.Question.fromPartial(e)) || [];
        message.blobIds = object.blobIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseOpenDisputeResponse() {
    return { disputeId: '' };
}
exports.OpenDisputeResponse = {
    fromJSON(object) {
        const message = {
            disputeId: isSet(object.disputeId) ? globalThis.String(object.disputeId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.disputeId !== '') {
            obj.disputeId = message.disputeId;
        }
        return obj;
    },
    create(base) {
        return exports.OpenDisputeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOpenDisputeResponse();
        message.disputeId = object.disputeId ?? '';
        return message;
    },
};
function createBaseRetractDisputeRequest() {
    return { transactionId: '' };
}
exports.RetractDisputeRequest = {
    fromJSON(object) {
        const message = {
            transactionId: isSet(object.transactionId) ? globalThis.String(object.transactionId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transactionId !== '') {
            obj.transactionId = message.transactionId;
        }
        return obj;
    },
    create(base) {
        return exports.RetractDisputeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRetractDisputeRequest();
        message.transactionId = object.transactionId ?? '';
        return message;
    },
};
function createBaseRetractDisputeResponse() {
    return {};
}
exports.RetractDisputeResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RetractDisputeResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRetractDisputeResponse();
        return message;
    },
};
/**
 * Dispute Service API.
 */
class DisputeServiceClient {
    rpc;
    name = 'com.step.issuing.proto.DisputeService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/issuing';
    methods = [{
            name: 'OpenDispute',
            requestType: exports.OpenDisputeRequest,
            responseType: exports.OpenDisputeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'RetractDispute',
            requestType: exports.RetractDisputeRequest,
            responseType: exports.RetractDisputeResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Opens a new dispute.
     */
    openDispute(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Retracts an open dispute.
     */
    retractDispute(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.DisputeServiceClient = DisputeServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=dispute-service.js.map